
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  name: 'InputGroup',
  props: ['formData'],
  setup(props) {
    const data = ref('');

    const stopWatch = watch(
      () => props.formData,
      (val) => {
        if (val.valsStr) {
          data.value = val.valsStr.split(',');
        }
        stopWatch();
      },
      { deep: true }
    );

    return {
      data
    };
  }
});
